import { initializeDB } from '../config/db';
import { PRACTICAL_EVALUATION_STORE, PRACTICAL_EVALUATION_TYPE_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const practicalEvaluationService = {
    // IndexedDB operations for evaluations (local drafts)
    async saveToIndexedDB(evaluation) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_STORE], 'readwrite');
            const store = tx.objectStore(PRACTICAL_EVALUATION_STORE);
            await store.put(evaluation);
            await tx.done;
            console.log('Practical Evaluation saved to IndexedDB:', evaluation.uuid);
            return evaluation;
        } catch (error) {
            console.error('Error saving to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_STORE], 'readonly');
            const store = tx.objectStore(PRACTICAL_EVALUATION_STORE);
            const evaluation = await store.get(uuid);
            return evaluation;
        } catch (error) {
            console.error('Error getting from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_STORE], 'readonly');
            const store = tx.objectStore(PRACTICAL_EVALUATION_STORE);
            const evaluations = await store.getAll();
            return evaluations;
        } catch (error) {
            console.error('Error getting all from IndexedDB:', error);
            throw error;
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_STORE], 'readwrite');
            const store = tx.objectStore(PRACTICAL_EVALUATION_STORE);
            await store.delete(uuid);
            await tx.done;
            console.log('Practical Evaluation deleted from IndexedDB:', uuid);
        } catch (error) {
            console.error('Error deleting from IndexedDB:', error);
            throw error;
        }
    },

    // IndexedDB operations for types (synced from server)
    async getTypesFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_TYPE_STORE], 'readonly');
            const store = tx.objectStore(PRACTICAL_EVALUATION_TYPE_STORE);
            const allTypes = await store.getAll();
            // Filter only active types and sort by sortOrder
            return (allTypes || [])
                .filter(t => t.isActive === true || t.isActive === 1)
                .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
        } catch (error) {
            console.error('Error getting types from IndexedDB:', error);
            throw error;
        }
    },

    async getTypeBySlugFromIndexedDB(slug) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([PRACTICAL_EVALUATION_TYPE_STORE], 'readonly');
            const store = tx.objectStore(PRACTICAL_EVALUATION_TYPE_STORE);
            const index = store.index('slug');
            const type = await index.get(slug);
            return type || null;
        } catch (error) {
            console.error('Error getting type by slug from IndexedDB:', error);
            throw error;
        }
    },

    // API operations
    async submit(evaluation) {
        try {
            const response = await axiosInstance.post('/practical-evaluation/submit', evaluation);
            return response.data;
        } catch (error) {
            console.error('Error submitting evaluation:', error);
            throw error;
        }
    },

    // Submit through Training Due endpoint
    async submitForTrainingDue(evaluation) {
        try {
            const response = await axiosInstance.post('/training-due/upload', {
                ...evaluation,
                formType: 'practical-evaluation'
            });
            return response.data;
        } catch (error) {
            console.error('Error submitting evaluation for training due:', error);
            throw error;
        }
    }
};

export default practicalEvaluationService;
